import React, { useEffect, useRef, useState } from 'react'
import styles from '../modalComponent.module.scss'
import moment from 'moment/moment'
import RightArrow from '../../../../../icons/rightArrowIcon.svg'
import LeftArrow from '../../../../../icons/leftArrowIcon.svg'
import Calendar from 'react-calendar'
import { useDispatch, useSelector } from 'react-redux'
import CalendarIcon from '../../../../../icons/calendar.svg'
import Input from '../../../../UiKitComponents/Input'
import cx from 'classnames'
import { reasonsOfAbsence } from '../../../../../constants/lists/relationshipList'
import { getReimbursements } from '../../../../../api/userApi'
import Button from '../../../../UiKitComponents/Button'
import { closeConfirmationModal } from '../../../../../redux/actions/confirmationModal'
import {
  setAuthPerson,
  setCommerciallyActive,
  setEditFromSummary,
  setFormCopy,
  setPrivateIndividual,
  updateQuiz,
} from '../../../../../redux/actions/quizQuestions'
import {
  setUpdateAuthorizedPerson,
  setUpdateCareQuizQuestions,
  setUpdateLegalRepresentations,
  setUpdateRepresentationByCommerciallyActive,
  setUpdateRepresentationByPrivateIndividual,
  setUpdateRepresentativePerson,
  updateAuthQuiz,
} from '../../../../../redux/actions/updateState'
import store from '../../../../../redux/store'
import {
  quizQuestions,
  representationByCommerciallyActive,
  representationByPrivateIndividual,
} from '../../../../../redux/defaultStates'
import {
  ListEntryRepresentationByCommerciallyActivePerson,
  listEntryRepresentationByPrivateIndividual,
} from '../../../../../constants/quizConstant'
import {
  setEmptyActive,
  setEmptyPrivate,
} from '../../../../../redux/actions/careReceipients'

const ChangeDateFromTo = () => {
  const { startFromJuly, formCopy } = useSelector((state) => state.quizQuestions)
  const { copyReimbursementRef } = useSelector((state) => state.payment)
  const { authorizedPerson } = useSelector((state) => state)
  const [parentStateFrom, setParentStateFrom] = useState(false)
  const [parentStateTo, setParentStateTo] = useState(false)
  const [parentStateReason, setParentStateReason] = useState(false)
  const currentDate = new Date()
  const [showCalendar, setShowCalendar] = useState(false)
  const [option, setOption] = useState(false)
  const wrapperRef = useRef(null)
  const [copiedForm, setCopiedForm] = useState('')
  const dispatch = useDispatch()
  const {
    commerciallyActive: { indexActive },
    privateIndividual: { indexPrivate },
  } = quizQuestions
  useEffect(() => {
    if (formCopy) {
      getReimbursements(copyReimbursementRef).then((data) => {
        console.log(data)
        setCopiedForm(data)
      })
    }
  }, [])
  console.log(parentStateTo)

  const convertToDate = (dateString) => {
    console.log(dateString)
    const [day, month, year] = dateString.toString().split('.')
    const date = new Date(year, month - 1, day)
    return date.toString()
  }
  const authOption = () => {
    if (!option) {
      setOption(true)
    } else {
      setOption(false)
    }
  }
  const handleChangeAuthCalendarFrom = (e) => {
    setParentStateFrom(moment(e).format('DD.MM.YYYY'))
    setShowCalendar(false)
  }
  const handleChangeAuthCalendarTo = (e) => {
    setParentStateTo(moment(e).format('DD.MM.YYYY'))
    setShowCalendar(false)
  }
  const handleReasonChange = () => {}
  const clickAuthOption = (e) => {
    setParentStateReason(e.target.innerText)
    setOption(false)
  }
  console.log(store.getState().quizQuestions.startFromJuly)
  const handleChangeCopy = () => {
    // dispatch(updateQuiz({ ...copiedForm.templateParams, chooseCard: 'smart' }))

    parentStateTo &&
      parentStateFrom &&
      parentStateReason &&
      dispatch(
        updateQuiz({
          ...copiedForm.templateParams,
          chooseCard: 'smart',
        }),
      )
    const newQuiz = store
      .getState()
      .quizQuestions.quizAuthorizedPerson.quizAuth.map((item) => {
        if (item.questionKey === 'periodOfAbsenceFrom') {
          return {
            ...item,
            answers: parentStateFrom,
          }
        }
        if (item.questionKey === 'periodOfAbsenceTo') {
          return {
            ...item,
            answers: parentStateTo,
          }
        }
        if (item.questionKey === 'reasonForTheAbsence') {
          return {
            ...item,
            answers: parentStateReason,
          }
        }
        return item
      })
    const updatedAuthPerson = newQuiz.filter(
      (item) => item.questionKey !== 'periodOfCare',
    )
    copiedForm.params?.startFromJuly
      ? dispatch(
          updateAuthQuiz(
            updatedAuthPerson,
            store.getState().quizQuestions.quizAuthorizedPerson.indexAuth,
          ),
        )
      : dispatch(
          setAuthPerson(
            newQuiz,
            store.getState().quizQuestions.quizAuthorizedPerson.indexAuth,
          ),
        )
    dispatch(
      setPrivateIndividual(
        [...listEntryRepresentationByPrivateIndividual],
        indexPrivate,
      ),
    )
    dispatch(
      setCommerciallyActive(
        [...ListEntryRepresentationByCommerciallyActivePerson],
        indexActive,
      ),
    )
    dispatch(
      setUpdateCareQuizQuestions({
        lastName: copiedForm.params?.careRecipients?.lastName,
        name: copiedForm.params.careRecipients?.name,
        birthday: copiedForm.params.careRecipients?.birthday,
        address: copiedForm.params.careRecipients?.address,
        houseNumber: copiedForm.params.careRecipients?.houseNumber,
        zipCode: copiedForm.params.careRecipients?.zipCode,
        city: copiedForm.params.careRecipients?.city,
        phoneNumber: copiedForm.params.careRecipients?.phoneNumber,
        insurance: copiedForm.params.careRecipients?.insurance,
        insuranceNumber: copiedForm.params.careRecipients?.insuranceNumber,
        levelOfCare: copiedForm.params.careRecipients?.levelOfCare,
        certificate: copiedForm.params.careRecipients?.certificate,
        legalRepresentation: copiedForm.params.careRecipients?.legalRepresentation,
      }),
    )
    dispatch(
      setUpdateLegalRepresentations({
        lastName: copiedForm.params.legalRepresentations?.lastName,
        name: copiedForm.params.legalRepresentations?.name,
        address: copiedForm.params.legalRepresentations?.address,
        houseNumber: copiedForm.params.legalRepresentations?.houseNumber,
        zipCode: copiedForm.params.legalRepresentations?.zipCode,
        city: copiedForm.params.legalRepresentations?.city,
        phoneNumber: copiedForm.params.legalRepresentations?.phoneNumber,
        document: copiedForm.params.legalRepresentations?.document,
      }),
    )
    !copiedForm.params?.startFromJuly
      ? dispatch(
          setUpdateAuthorizedPerson({
            lastName: copiedForm.params.authorizedPerson?.lastName,
            name: copiedForm.params.authorizedPerson?.name,
            birthday: copiedForm.params.authorizedPerson?.birthday,
            address: copiedForm.params.authorizedPerson?.address,
            houseNumber: copiedForm.params.authorizedPerson?.houseNumber,
            zipCode: copiedForm.params.authorizedPerson?.zipCode,
            city: copiedForm.params.authorizedPerson?.city,
            phoneNumber: copiedForm.params.authorizedPerson?.phoneNumber,
            professionalCarer: copiedForm.params.authorizedPerson?.professionalCarer,
            periodOfCare: copiedForm.params.authorizedPerson?.periodOfCare,
            periodOfAbsenceFrom: parentStateFrom,
            periodOfAbsenceTo: parentStateTo,
            reasonForTheAbsence: parentStateReason,
            durationOfAbsence: copiedForm.params.authorizedPerson?.durationOfAbsence,
          }),
        )
      : dispatch(
          setUpdateAuthorizedPerson({
            lastName: copiedForm.params.authorizedPerson?.lastName,
            name: copiedForm.params.authorizedPerson?.name,
            birthday: copiedForm.params.authorizedPerson?.birthday,
            address: copiedForm.params.authorizedPerson?.address,
            houseNumber: copiedForm.params.authorizedPerson?.houseNumber,
            zipCode: copiedForm.params.authorizedPerson?.zipCode,
            city: copiedForm.params.authorizedPerson?.city,
            phoneNumber: copiedForm.params.authorizedPerson?.phoneNumber,
            professionalCarer: copiedForm.params.authorizedPerson?.professionalCarer,
            // periodOfCare: copiedForm.params.authorizedPerson?.periodOfCare,
            periodOfAbsenceFrom: parentStateFrom,
            periodOfAbsenceTo: parentStateTo,
            reasonForTheAbsence: parentStateReason,
            durationOfAbsence: copiedForm.params.authorizedPerson?.durationOfAbsence,
          }),
        )

    dispatch(
      setUpdateRepresentativePerson({
        lastName: copiedForm.params.representativePerson?.lastName,
        name: copiedForm.params.representativePerson?.name,
        address: copiedForm.params.representativePerson?.address,
        houseNumber: copiedForm.params.representativePerson?.houseNumber,
        zipCode: copiedForm.params.representativePerson?.zipCode,
        city: copiedForm.params.representativePerson?.city,
        phoneNumber: copiedForm.params.representativePerson?.phoneNumber,
        personRepresenting:
          copiedForm.params.representativePerson?.personRepresenting,
        commerciallyActive:
          copiedForm.params.representativePerson?.commerciallyActive,
        relationshipList: copiedForm.params.representativePerson?.relationshipList,
        relationshipByMarriage:
          copiedForm.params.representativePerson?.relationshipByMarriage,
        sameHousehold: copiedForm.params.representativePerson?.sameHousehold,
        relationship: copiedForm.params.representativePerson?.relationship,
      }),
    )
    dispatch(
      setEmptyPrivate({
        ...representationByPrivateIndividual,
      }),
    )
    dispatch(
      setEmptyActive({
        ...representationByCommerciallyActive,
      }),
    )
    dispatch(setFormCopy(true))
    dispatch(closeConfirmationModal())
  }
  return (
    <section>
      <div className={styles.changeDate}>
        <p>Beantworten Sie mir bitte folgende Fragen</p>
        <div>
          <div>
            <p>
              Wann ist die normalerweise pflegende Person verhindert oder verhindert
              gewesen?{' '}
            </p>
            <div>
              <div>
                <Input
                  placeholder={'Von'}
                  calendar
                  value={
                    parentStateFrom
                      ? moment(convertToDate(parentStateFrom)).format('DD.MM.YYYY')
                      : ''
                  }
                  calendarIcon={CalendarIcon}
                  calendarValue={
                    parentStateFrom
                      ? moment(convertToDate(parentStateFrom)).format('DD.MM.YYYY')
                      : 'Von'
                  }
                  onChangeCalendar={handleChangeAuthCalendarFrom}
                  // minDate={
                  //   startFromJuly
                  //     ? new Date(convertToDate('01.07.2025'))
                  //     : parentStateTo && new Date(convertToDate(parentStateFrom))
                  // }
                  // maxDate={new Date(convertToDate(parentStateTo))}
                  minDate={
                    copiedForm.params?.startFromJuly && !parentStateFrom
                      ? new Date(convertToDate('01.07.2025'))
                      : parentStateTo && new Date(convertToDate(parentStateFrom))
                  }
                  maxDate={
                    !copiedForm.params?.startFromJuly &&
                    !parentStateFrom &&
                    new Date(convertToDate('30.06.2025'))
                  }
                  defaultActiveStartDate={
                    copiedForm.params?.startFromJuly
                      ? new Date(new Date('01.07.2025').getFullYear(), 6)
                      : new Date(new Date('01.06.2025').getFullYear(), 5)
                  }
                />
              </div>
              <div>
                <Input
                  placeholder={'Bis'}
                  calendar
                  value={
                    parentStateTo
                      ? moment(convertToDate(parentStateTo)).format('DD.MM.YYYY')
                      : ''
                  }
                  calendarIcon={CalendarIcon}
                  calendarValue={
                    parentStateTo
                      ? moment(convertToDate(parentStateTo)).format('DD.MM.YYYY')
                      : 'Bis'
                  }
                  onChangeCalendar={handleChangeAuthCalendarTo}
                  // minDate={
                  //   parentStateFrom ? new Date(convertToDate(parentStateFrom)) : null
                  // }
                  minDate={new Date(convertToDate(parentStateFrom))}
                  maxDate={
                    !copiedForm.params?.startFromJuly &&
                    !parentStateFrom &&
                    new Date(convertToDate('30.06.2025'))
                  }
                  defaultActiveStartDate={
                    copiedForm.params?.startFromJuly
                      ? new Date(new Date('01.07.2025').getFullYear(), 6)
                      : new Date(new Date('01.06.2025').getFullYear(), 5)
                  }
                />
              </div>
            </div>
          </div>
          <div>
            <p>
              Weshalb ist die Person verhindert ? Bitte wählen Sie einen Grund aus
              der Liste aus.
            </p>
            <div
              className={cx(styles.optionChange, { [styles.clickedIcon]: !!option })}
              onClick={authOption}
            >
              <img src={RightArrow} alt={RightArrow} />
              <div
                className={cx(styles.select, {
                  [styles.placeholder]: parentStateReason,
                })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && parentStateReason) handleReasonChange()
                }}
                ref={wrapperRef}
              >
                {parentStateReason ? parentStateReason : 'Bitte wählen Sie'}
              </div>
              {!!option && (
                <div className={styles.option}>
                  {reasonsOfAbsence.map((item) => {
                    return <div onClick={clickAuthOption}>{item}</div>
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
        <Button
          small
          smallPrimaryBg
          onClick={() => {
            handleChangeCopy()
            dispatch(closeConfirmationModal())
          }}
          disabled={!parentStateFrom || !parentStateReason || !parentStateTo}
        >
          Weiter
        </Button>
      </div>
    </section>
  )
}
export default ChangeDateFromTo
